import {useState} from 'react';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

// The BE marks financing promo cards PENDING ~1–2 s after an album or promo change and finishes
// the new renders ~10 s later; the window keeps the gallery polling until both are observed.
export const FINANCING_RENDER_WINDOW_DURATION = 30_000;

type FinancingRenderWindow = {saleVehicleId: string};

/**
 * Opens a time window after a gallery change in which the gallery polls the financing status,
 * even while its cached status shows no PENDING card. The window belongs to one sale vehicle,
 * so another vehicle shown by the same gallery does not inherit it.
 */
export const useFinancingRenderWindow = (saleVehicleId: string | Nullish) => {
  const [renderWindow, setRenderWindow] = useState<FinancingRenderWindow | null>(null);

  const startRenderWindow = () => {
    if (isNil(saleVehicleId)) {
      return;
    }

    const nextRenderWindow = {saleVehicleId};
    setRenderWindow(nextRenderWindow);
    // A later change restarts the window, so only the latest window may close it.
    setTimeout(
      () => setRenderWindow((current) => (current === nextRenderWindow ? null : current)),
      FINANCING_RENDER_WINDOW_DURATION
    );
  };

  return {
    startRenderWindow,
    isRenderWindowOpen: !isNil(saleVehicleId) && renderWindow?.saleVehicleId === saleVehicleId,
  };
};
